import React from 'react';
import { useContext } from "react";
import styled from 'styled-components';
import IconosGenerales from '../iconos/IconosGenerales';
import IconosRedes from '../iconos/IconosRedes';
import ImagenCurso from './../../img/logo_tuscursossepe_grande.png';
import FondoHeader from '../../img/patter_menu_claro.png';
import LinksHeader from '../eventos/LinksHeader';
import TextoLi from './TextoLi';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';
import { isMobile, isTablet } from 'react-device-detect';
import {
    Container,
    Nav,
    Navbar,

} from 'react-bootstrap';
import { CategoriasContext } from "../../../peticiones_API/Peticiones_Categorias";




import AnimacionScroll from './../eventos/AnimacionScroll';


// Estilos de ejemplo

const ImgCurso = styled.img`
    width: 250px;
`;
function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey);
    return (

        <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={decoratedOnClick}>
            {children}
        </Navbar.Toggle>
    );
}

//Header principal de todas las páginas
const Header = (props) => {

    const { categorias, cargaCat} = useContext(CategoriasContext);

    return (
        <>
            <AnimacionScroll></AnimacionScroll>
            {props.noTelEmail ? (
                <>
                    <Navbar className="bg-body-tertiary">
                        <HeaderProps>

                        </HeaderProps>
                    </Navbar>
                    <Accordion defaultActiveKey="0">
                        <Card>
                            <StyledNavbar expand="lg">
                                <Container>
                                    <Link to="/">
                                        <ImgCurso src={ImagenCurso} />
                                    </Link>


                                    {(isMobile || isTablet) ? (
                                        <CustomToggle eventKey="1"></CustomToggle>
                                    ) : (
                                        <>
                                            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                            <Navbar.Collapse id="responsive-navbar-nav">
                                                <StyledNav className="me-auto">
                                                    <LinksHeader to="/">
                                                        <span>INICIO</span>
                                                    </LinksHeader>

                                                    {!cargaCat &&
                                                        categorias.map((cat) =>
                                                            cat.SubCategoria.length > 0 ? (
                                                                <React.Fragment key={cat.Id}>
                                                                    <LinksHeader to={`/cursos/${cat.urlCat}/subcategorias`}>
                                                                        <span>{cat.categoria.toUpperCase()}</span>
                                                                    </LinksHeader>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment key={cat.Id}>
                                                                    <LinksHeader to={`/cursos/${cat.urlCat}`}>
                                                                        <span>{cat.categoria.toUpperCase()}</span>
                                                                    </LinksHeader>
                                                                </React.Fragment>
                                                            )
                                                        )}

                                                    <LinksHeader to="/contactar">
                                                        <span>CONTACTO</span>
                                                    </LinksHeader>
                                                </StyledNav>
                                            </Navbar.Collapse>

                                        </>
                                    )}

                                </Container>
                            </StyledNavbar>
                            {(isMobile || isTablet) && (
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body style={{ background: "#EE805D" }}>
                                        <StyledNav className="d-grid gap-3 p-5 " style={{ background: "#EE805D" }}>
                                            <LinksHeader to="/">
                                                <span >INICIO</span>
                                            </LinksHeader>
                                            {!cargaCat &&
                                                categorias.map((cat) =>
                                                    cat.SubCategoria.length > 0 ? (
                                                        <React.Fragment key={cat.Id}>
                                                            <LinksHeader to={`/cursos/${cat.urlCat}/subcategorias`}>
                                                                <span>{cat.categoria.toUpperCase()}</span>
                                                            </LinksHeader>
                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment key={cat.Id}>
                                                            <LinksHeader to={`/cursos/${cat.urlCat}`}>
                                                                <span>{cat.categoria.toUpperCase()}</span>
                                                            </LinksHeader>
                                                        </React.Fragment>
                                                    )
                                                )}
                                            <LinksHeader to="/contactar">
                                                <span>CONTACTO</span>
                                            </LinksHeader>
                                        </StyledNav>
                                    </Card.Body>
                                </Accordion.Collapse>
                            )}

                        </Card>
                    </Accordion>
                </>
            ) : (
                <>
                    <Navbar className="bg-body-tertiary">
                        <Container>
                            <StyledNavbarBrand>
                                <IconosGenerales id="telefono" />
                                <Link to="tel:+34943211151%20"><TextoLi>672 61 02 67</TextoLi></Link>
                            </StyledNavbarBrand>
                            <StyledNavbarBrand>
                                <TextoLi>|</TextoLi>
                            </StyledNavbarBrand>
                            <StyledNavbarBrand>
                                <IconosGenerales id="correo" />
                                <Link to="mailto:info@tuscursossepe.com"><TextoLi>info@tuscursossepe.com</TextoLi></Link>
                            </StyledNavbarBrand>
                            <Navbar.Toggle />
                            <Navbar.Collapse className="justify-content-end">
                                <LinkRedes to="https://www.facebook.com/people/Tus-Cursos-SEPE/100076320754305/">
                                    <IconosRedes id="facebook" header="true" />
                                </LinkRedes>
                                <LinkRedes to="https://www.instagram.com/tuscursossepe/">
                                    <IconosRedes id="instagram" header="true" />
                                </LinkRedes>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>


                    <Accordion defaultActiveKey="0">
                        <Card>
                            <StyledNavbar expand="lg">
                                <Container>
                                    <Link to="/">
                                        <ImgCurso src={ImagenCurso} />
                                    </Link>


                                    {(isMobile || isTablet) ? (
                                        <CustomToggle eventKey="1"></CustomToggle>
                                    ) : (
                                        <>
                                            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                            <Navbar.Collapse id="responsive-navbar-nav">
                                                <StyledNav className="me-auto">
                                                    <LinksHeader to="/">
                                                        <TituloHeader>INICIO</TituloHeader>
                                                    </LinksHeader>
                                                    {!cargaCat &&
                                                        categorias.map((cat) =>
                                                            cat.SubCategoria.length > 0 ? (
                                                                <React.Fragment key={cat.Id}>
                                                                    <LinksHeader to={`/cursos/${cat.urlCat}/subcategorias`}>
                                                                        <TituloHeader>{cat.categoria.toUpperCase()}</TituloHeader>
                                                                    </LinksHeader>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment key={cat.Id}>
                                                                    <LinksHeader to={`/cursos/${cat.urlCat}`}>
                                                                        <TituloHeader>{cat.categoria.toUpperCase()}</TituloHeader>
                                                                    </LinksHeader>
                                                                </React.Fragment>
                                                            )
                                                        )}
                                                    <LinksHeader to="/contactar">
                                                        <TituloHeader>CONTACTO</TituloHeader>
                                                    </LinksHeader>
                                                </StyledNav>
                                            </Navbar.Collapse>
                                        </>
                                    )}

                                </Container>
                            </StyledNavbar>
                            {(isMobile || isTablet) && (
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body style={{ background: "#EE805D" }}>
                                        <StyledNav className="d-grid gap-3 p-5 " style={{ background: "#EE805D" }}>
                                            <LinksHeader to="/">
                                                <TituloHeader >INICIO</TituloHeader>
                                            </LinksHeader>
                                            {!cargaCat &&
                                                categorias.map((cat) =>
                                                    cat.SubCategoria.length > 0 ? (
                                                        <React.Fragment key={cat.Id}>
                                                            <LinksHeader to={`/cursos/${cat.urlCat}/subcategorias`}>
                                                                <TituloHeader>{cat.categoria.toUpperCase()}</TituloHeader>
                                                            </LinksHeader>
                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment key={cat.Id}>
                                                            <LinksHeader to={`/cursos/${cat.urlCat}`}>
                                                                <TituloHeader>{cat.categoria.toUpperCase()}</TituloHeader>
                                                            </LinksHeader>
                                                        </React.Fragment>
                                                    )
                                                )}
                                            <LinksHeader to="/contactar">
                                                <TituloHeader>CONTACTO</TituloHeader>
                                            </LinksHeader>
                                        </StyledNav>
                                    </Card.Body>
                                </Accordion.Collapse>
                            )}

                        </Card>
                    </Accordion>
                </>
            )
            }
        </>
    );
}

const LinkRedes = styled(Link)`
    &:hover {
        svg {
            color: #EE805D !important;
        }
    }
`;

const StyledNavbarBrand = styled(Navbar.Brand)`
  
    margin:0% 0% 1% 0% !important;

    font-size: 15px !important;

    @media screen and (max-width: 768px) {
    font-size: 10px !important; 
    }

`;

const TituloHeader = styled.span`
  
    font-size: 17px;
`;



const StyledNavbar = styled(Navbar)`
    background-color: #EE805D !important;
    background-image: url(${FondoHeader}); 
    background-size: contain; 
    background-position: center; 
    height: 120px !important;
    position: relative; 

    @media only screen and (max-width: 767px) {
        height: 130px !important;
    }
`;

const StyledNav = styled(Nav)`
  
    margin-left: 30% !important; 
    background: #EE805D;

    @media only screen and (max-width: 720px) {
        background: #fff;
        margin: -3% !important; 
    }
    
  

`;

const HeaderProps = styled(Container)`
    margin-bottom: 30px;
`

export default Header;